<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <path
      d="M17.3333 14H15.3333C14.9797 14 14.6406 14.1405 14.3905 14.3905C14.1405 14.6406 14 14.9797 14 15.3333V17.3333M26 17.3333V15.3333C26 14.9797 25.8595 14.6406 25.6095 14.3905C25.3594 14.1405 25.0203 14 24.6667 14H22.6667M22.6667 26H24.6667C25.0203 26 25.3594 25.8595 25.6095 25.6095C25.8595 25.3594 26 25.0203 26 24.6667V22.6667M14 22.6667V24.6667C14 25.0203 14.1405 25.3594 14.3905 25.6095C14.6406 25.8595 14.9797 26 15.3333 26H17.3333"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
